import { hover } from 'pobble-components/dist/jss-mixins'

export default {
  menuItem: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px 24px 10px 16px',
    cursor: 'pointer',
    '&:first-child': {
      margin: '0'
    },
    ...hover({
      backgroundColor: 'rgba(0, 0, 0, 0.02)'
    }),
    '&:active': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)'
    }
  },
  disabled: {
    opacity: '0.7',
    ...hover({
      backgroundColor: 'transparent'
    })
  }
}
